import React, { useContext, useEffect, useState, forwardRef } from "react";
import { DonutChart, DonutChartItem } from "react-charts";
import { Route, RouterProvider, Routes, createBrowserRouter, useLocation, useMatch, useNavigate, useNavigation, useParams } from "react-router-dom";
import { BotMessageModal } from "../BotMessageModal";
import { BotStore, useBot } from "../Store";
import { Bot, logoutBot } from "../bot-loaders";
import { Modal } from "../components/Modal";
import { BotPicture } from "./bot-list";
import { loadBotMessageChartData } from "./message-chart-loader";
import { sleep, sum } from "../../../simple-utils/dist";
import { SiteHeader } from "../SiteHeader";
import { CampaignIndex } from "../campaign/campaign-index";
import { Loading } from "../components/Loading";
import { BotTodayReport } from "./BotTodayReport";
import { DownloadContactButton, DownloadGroupsButton } from "./DownloadContactsButton";
import { TermToContactList } from "./TermToContatcList";
import { BotDailyReport } from "./BotDailyReport";
import { useConfirm } from "../components/Dialogs";
import { ReactTooltip } from "tooltip";
import { BackButton, BackButtonBar } from "../comps/BackButton";
import { ContactExportingButton } from "../audience/contact-exporter";
import { BotResetDialog } from "./BotResetDialog";


function SendMessageButton({bot}:{bot:Bot}){
    const [show, setShow] = useState(false);
    
    return <>
        <ReactTooltip className="align-top me-2 mb-2" tooltip="Envie uma mensagem de teste para testar a sua conexão">
            <button className="btn btn-info" onClick={() => setShow(true)}>
                <i className="fa fa-comment"></i> Enviar Mensagem
            </button>
        </ReactTooltip>
        {show && <Modal title={bot.name} onHide={() => setShow(false)}>
                <BotMessageModal bot={bot} />
            </Modal>}
    </>
}

function donutTooltip(item:DonutChartItem, setup: any){
    return <>
        <div className="mb-2">
           <b> {item.label} </b> <br />
         <b className={`${item.style} bg-color badge` }>{(item.value / setup.total * 100).toFixed(1) + "%"}</b></div>
        <div className="">{item.value} Mensagens</div>
    </>
}

function MessageChart({bot}:{bot:Bot}){
    const [data, setData] = useState<DonutChartItem[]>(null);
    const [today, setToday] = useState(false);
    const [showResetModal, setShowResetModal] = useState(false);
    useEffect(() => {
        setData(null);
        (async function(){
            await sleep(1000);
            setData(await loadBotMessageChartData(bot, today));
        })()
    }, [bot.id, today]);
    const navigate = useNavigate();
    const {dispatch} = useContext(BotStore);

    
    const count = data == null ? null : sum(Object.values(data), a => a.value);

    async function resetHandle(newBot:Bot){
        dispatch({type:"updateBot", payload: newBot})
        navigate("/");
    }

    
    return <>
        { data == null && <div className="card"><div className="card-body">
                <div className="d-flex"></div><Loading /></div></div> }
        {data !== null && count == 0 &&
            <div className="card"><div className="card-body">
                Nenhuma mensagem enviada {' '}{today ? 'hoje' : 'nos últimos 28 dias'}.
            </div></div>
        }
        {data !== null && count > 0 &&
            <div className="card"><div className="card-body">
                <div className="d-flex">
                    <p className="flex-grow-1"><b>{count}</b> mensagens enviadas  {' '}{today ? 'hoje' : 'nos últimos 28 dias'}</p>
                    <div>
                        <button className="btn btn-sm btn-info" onClick={() => setToday(!today)}>{today ? 'Ver últimos 28 dias' : 'Ver hoje'}</button>
                    </div>
                </div>
                <DonutChart key={`${bot.id}-${today ? 'today' : 'month'}`} className='mt-4 d-sm-flex align-items-center' data={data} height={180} width={192} radius={55} thickness={20} textRadiusOffset={80} createTooltip={donutTooltip} />
                {!today && <BotDailyReport bot={bot} />}
            </div></div>
        }        
        <div className="mt-4">
            <button className="btn btn-primary me-2 mb-2" onClick={() => setShowResetModal(true)}>
                <i className="fa fa-person-walking-arrow-right"></i> Desconectar / Parar
            </button>
            {showResetModal && <Modal title="Desconectar / Parar" onHide={()=>setShowResetModal(true)}>
                    <BotResetDialog bot={bot} onAction={resetHandle} />
                </Modal>}
            {/*<DownloadContactButton bot={bot} />*/}
            <ContactExportingButton bot={bot} />
            { [191,5,1,3].includes(bot.id) &&  <DownloadGroupsButton bot={bot} /> }
            <SendMessageButton bot={bot} />
        </div>
    </>
}

function Home(){
    const {botId} = useParams();
    const navigate = useNavigate()

    return <a className="btn btn-primary mt-4" onClick={() => navigate(`/bot/${botId}/messages`)}>to messages</a>
}


function Link({label, id, path}: {label:string, id:string, path:string}){
    const navigate = useNavigate();
    const match = useMatch(`/bot/:id${path}${path == '' ? '' : '/*'}`);
    return <a className={`btn ${match ? 'btn-primary' :'btn-outline-primary'}`} onClick={() => navigate(`/bot/${id}${path}`, {replace:true})}>{label}</a>
}

const LinkRef = forwardRef(({label, id, path, interactions}: {label:string, id:string, path:string, interactions: object}, ref:React.Ref<HTMLAnchorElement>) => {
    const navigate = useNavigate();
    const match = useMatch(`/bot/:id${path}${path == '' ? '' : '/*'}`);
    return <a ref={ref} {...interactions} className={`btn ${match ? 'btn-primary' :'btn-outline-primary'}`} onClick={() => navigate(`/bot/${id}${path}`, {replace:true})}>{label}</a>
});



export function BotPage(){
    const {botId} = useParams();
    const bot = useBot(parseInt(botId));
    
    const location = useLocation();

    return <div className="container my-4">
        <SiteHeader />
        <BotHeader bot={bot} />

        <div className="actions my-4">
            {/* <SendMessageButton bot={bot} /> */}
            <ReactTooltip forward={true} delay={300} tooltip="Veja estátisticas do envio de mensages para este bot." >{(ref, i) => <LinkRef ref={ref} interactions={i} id={botId} label="Principal" path="" />}</ReactTooltip>
            { false && <Link id={botId} label="Mensagens" path="/messages" />}
            <ReactTooltip forward={true} delay={300} tooltip="Crie e veja as campanhas de mensagem deste bot.">{(ref, i) => <LinkRef ref={ref} interactions={i} id={botId} label="Campanhas" path="/campaigns/" />}</ReactTooltip>
            {/*<ReactTooltip forward={true} delay={300} tooltip="Veja um resumo das mensagens enviadas hoje." >{(ref, i) => <LinkRef ref={ref} interactions={i} id={botId} label="Hoje" path="/today/" />}</ReactTooltip>*/}
            { false && <Link id={botId} label="Busca" path="/busca" />}
        </div>

        <Routes>
            <Route path="/" element={<MessageChart bot={bot} />} />
            <Route path="/messages" element={<div className="mt-4">Mensagens</div>} />
            <Route path="/today" element={<BotTodayReport bot={bot} />} />
            <Route path="/busca" element={<TermToContactList bot={bot} />} />
            <Route path="/campaigns/*" element={<CampaignIndex bot={bot} />} />
        </Routes>
        
    </div>
}

function BotHeader({bot}:{bot:Bot}){
    return  <BackButtonBar><div className="bot-header d-flex">
        <BotPicture bot={bot} />
        <div>
            {bot.name} <br />
            <small className="text-muted">{bot.status}{bot.status == 'online' && <span className="opacity-75">{" ("}{bot.phone}{")"}</span>}</small>
        </div>
    </div>
    </BackButtonBar> 
}